export default __webpack_public_path__ + "static/media/gatis.faf02cb9.jpg";